import React, {Component} from 'react';
import {Redirect} from 'react-router-dom';
import {PostData} from '../../services/PostData';
import {GetData} from '../../services/GetData';
import {
  Row,
  Col,
  Button,
  ButtonDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Card,
  CardHeader,
  CardFooter,
  CardBody,
  Collapse,
  Form,
  FormGroup,
  FormText,
  Label,
  Input,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
  Table
} from 'reactstrap';
import $ from 'jquery';
import StaffPage from '../../views/StaffPage/';

class Designation extends Component {
	
	/** set property value **/
	constructor(props){
		super(props);
		this.state = {
			id : '',
			design : '',
			_message : '',
			alertClass :'',
			posts : [],
			isedit : 0,
		}
		this.onChange = this.onChange.bind(this);
		this.onSubmit = this.onSubmit.bind(this);
		this.onUpdateSubmit = this.onUpdateSubmit.bind(this);
		this.handleClick = this.handleClick.bind(this);
		this.onClick = this.onClick.bind(this);
	}
	
	onClick(e){
		document.getElementById("editform").reset();
		this.setState({isedit : 0,design : ''});
		$("#designation").val('');
		document.getElementById("userform").reset();
	}
	
	onChange(e){
		this.setState({[e.target.name]:e.target.value});
	}
	
	onSubmit(e){
		e.preventDefault();
		
		if(this.state.design){
			$("#showLoader").show();
			PostData('designation/add',this.state).then((result) => {
				$("#showLoader").hide();
				let responseJson = result;
				if(responseJson.status == '1' ){
					this.setState({
						_message:'Designation Added Successfully!..',
						alertClass:'alert alert-success',
					});
					document.getElementById("userform").reset();
					this.getdata();
				}
				else{
			
					this.setState({
						_message:'Already Added',
						alertClass:'alert alert-danger'
					});
				}
			});
		
		}
	
	}
	
	onUpdateSubmit(e){
		e.preventDefault();
		
		if(this.state.design){
			$("#showLoader").show();
			PostData('designation/update',this.state).then((result) => {
				$("#showLoader").hide();
				let responseJson = result;
				if(responseJson.status == '1' ){
					document.getElementById("editform").reset();
					this.setState({
						_message:'Designation Updated Successfully!..',
						alertClass:'alert alert-success',
						isedit : 0
					});
					this.getdata();
				}
				else{
					this.setState({
						_message:'Designation Already Added..',
						alertClass:'alert alert-danger'
					});
				}
			});	
		}
	}

	handleEditClick(id){

		var index = this.state.posts.findIndex(function(obj){
			return (obj.id == id);
		})
		this.setState({design : this.state.posts[index]['designation'], id :id,isedit : 1});
	}

	componentDidMount() {
		 
		this.getdata();
	}
	
	getdata(){
		$("#showLoader").show();
		GetData('designation/getdesignation').then((result) => {
			$("#showLoader").hide();
			let responseJson = result;
			if(responseJson){
				this.setState({
					posts : responseJson
				});
			}
		});
	}
	
	handleClick(dd){
		
		this.state.id = dd;
		if (window.confirm("Do you want to Delete?")) { 		
			PostData('designation/deletedesignation',this.state).then((result) => {
				let responseJson = result;
				if(responseJson.status == '1'){
					this.setState({
						_message:'Designation Removed Successfullly',
						alertClass:'alert alert-success'
					});
					this.getdata();
				}
				else{
			
					this.setState({
						_message:'Error in Remove Designation',
						alertClass:'alert alert-danger'
					});
				}
			});
		}
	}
	
  render() {
	  
    return (
		<div>
		  <StaffPage />
			<div className="animated fadeIn">
				<div className={this.state.alertClass}>
					{this.state._message}
				</div>
				<Row>
				{this.state.isedit == 0 ?
				  <Col md="5">
					<Card>
					  <form action="" method="post" role="form" id="userform" encType="multipart/form-data" onSubmit={this.onSubmit} >
						<CardHeader>
							<strong>Add Designation</strong>
						</CardHeader>
						<CardBody>
							<Row>
							  <Col md="12">
								<FormGroup>
								  <Label htmlFor="name">Designation <span className="text-danger">*</span></Label>
								  <Input type="text" name="design" required onChange={this.onChange} />
								</FormGroup>
							  </Col>
							</Row>
						</CardBody>
						<CardFooter>
							<Button type="submit" size="sm" color="primary"><i className="fa fa-dot-circle-o"></i> Submit</Button>
							<Button type="reset" size="sm" color="danger" onClick={this.onClick}><i className="fa fa-ban"></i> Reset</Button>
						</CardFooter>
					  </form>
					</Card>
					</Col> : 
					<Col md="5">
					<Card>
					  <form action="" method="post" role="form" id="editform" encType="multipart/form-data" onSubmit={this.onUpdateSubmit} >
						<CardHeader>
							<strong>Edit Designation</strong>
							<Button type="reset" size="sm" style={{float : 'right'}} color="primary" onClick={this.onClick}>Add</Button>
						</CardHeader>
						<CardBody>
							<Row>
							  <Col md="12">
								<FormGroup>
								  <Label htmlFor="name">Designation <span className="text-danger">*</span></Label>
								  <Input type="text" name="design" required onChange={this.onChange} value={this.state.design} />
								</FormGroup>
							  </Col>
							</Row>
						</CardBody>
						<CardFooter>
							<Button type="submit" size="sm" color="primary"><i className="fa fa-dot-circle-o"></i> Update</Button>
						</CardFooter>
					  </form>
					</Card>
					</Col> }
				  <Col md="7">
				   <Card>
					<CardBody>
					<Table responsive bordered>
						<thead>
							<tr>
								<th>S.No</th>
								<th>Designation</th>
								<th width="100">Manage</th>
							</tr>
						</thead>
						<tbody>
							{this.state.posts.map((item,i) =>
							 
								<tr key = {item}>
									<td>{i+1}</td>
									<td>{item.designation}</td>
									<td>
										<button name="editsub" className="btn btn-info btn-sm" onClick={() => this.handleEditClick(item.id)} ><i className="fa fa-edit"></i></button>&nbsp;
										<button name="removesub" className="btn btn-danger btn-sm" onClick={() => this.handleClick(item.id)} ><i className="fa fa-remove"></i></button>
									</td>
								</tr>
				  
							 )}
						</tbody>
					</Table>
					</CardBody>
				   </Card>
				  </Col>
				</Row>
			</div>
		</div>
	)
  }
}

export default Designation;


// WEBPACK FOOTER //
// ./src/employee/Designation/Designation.js